import React, { Component } from 'react';
import LanguageContext from '../context/LanguageContext';

export default WrappedComponent =>
    class LanguageContextWrapper extends Component {
        render() {
            return <LanguageContext.Consumer>
                { language => <WrappedComponent {...this.props} language={language} isEn={language === 'en'} /> }
            </LanguageContext.Consumer>;
        }
    }
